import { TextField } from "@mui/material";
import i18next from "i18next";
import React, { useEffect } from "react";

import { useNavigate } from "react-router";
import Button from "../../components/Button";
import Label from "../../components/Label";
import Loader from "../../components/Loader";
import SimpleDialog from "../../components/SimpleDialog";
import Table from "../../components/Table";
import * as formationsServices from "../../services/formationsServices";
import { constants, routes, utils } from "../../utils";

type Params = { search: string; skip: number; limit: number };

const columns = ["name"];

export default function FormationsList() {
	const [data, setData] = React.useState<any>({ result: [], total: 0 });
	const [params, setParams] = React.useState<Params>({ search: "", skip: 0, limit: constants.DEFAULT_PAGE_SIZE });
	const [loading, setLoading] = React.useState<boolean>(false);

	const navigate = useNavigate();

	const goBack = () => navigate("/", { replace: true });

	useEffect(() => {
		getFormations(params);
	}, []);

	const getFormations = async (newParms: Params) => {
		setLoading(true);
		const response = await formationsServices.search(newParms);
		setData(response);
		setLoading(false);
	};

	const handleUpdate = (options: any) => {
		getFormations({ ...params, ...options });
	};

	const handleChangeSearch = utils.debounce((e) => {
		var newParms = params;
		newParms = { ...params, search: e.target.value };

		getFormations(newParms);
		setParams({ ...newParms });
	}, constants.DEBOUNCE_TIME);

	return (
		<SimpleDialog open={true} onClose={goBack}>
			<Label className="mb-3" isTitle text={i18next.t("formations")} />
			<Table
				onRowPress={(formation) => navigate(routes.FORMATION(formation.id))}
				keyExtractor={(row) => row.id}
				columns={columns}
				rows={data.result}
				total={data.total}
				handleUpdate={handleUpdate}
				filtersComponents={
					<div className="d-flex align-items-center my-3">
						<TextField
							size="small"
							placeholder={i18next.t("search")}
							inputProps={{ "data-testid": "search-input" }}
							onChange={handleChangeSearch}
						/>
					</div>
				}
			/>
			<div className="d-flex mt-4 justify-content-between">
				{loading ? <Loader /> : <div />}
				<Button
					label={i18next.t("go-back")}
					secondary
					onClick={() => navigate(routes.DASHBOARD)}
					className="ms-4"
				/>
			</div>
		</SimpleDialog>
	);
}
